import * as React from 'react';
import { Asset } from '../../Model/Asset';
import { ProductInterface } from '../../Model/Product';
import { Trans } from '../Trans';
import { ProductView } from './ProductView';

export interface DownloadProps {
    product: ProductInterface | undefined,
    attr: string
    /**
     * Specify if the "download" attribute should be added to the link
     */
    download?: boolean
    title?: string
    hideIcon?: boolean
}

export class FinderDownload extends ProductView<DownloadProps> {
    public render() {
        const props = this.props;
        const product = props.product;
        if (!product) {
            return null;
        }

        const asset = this.getAsset(props.attr, product);
        const assetBase = `${process.env.REACT_APP_ASSET_URL}`;

        if (asset) {
            // eslint-disable-next-line react/jsx-no-target-blank
            return <a href={assetBase + asset.uri} className="pf-download" download={props.download} target="_blank">
                <div className="pf-download-icon">
                    <i className="fas fa-file-pdf"/>
                </div>

                <div className="pf-download-text">
                    {props.title ? <Trans>{props.title}</Trans> : asset.displayString}
                </div>
            </a>;
        } else {
            return null;
        }
    }

    private getAsset(key: string, product: ProductInterface): Asset | undefined {
        if (key.substr(0, 8) === '@parent.') {
            return this.asset(product.parent, key.substr(8));
        } else {
            return this.asset(product, key);
        }
    }
}
